<template>
    <section class="relative font-ww-medium">
      <!-- Background Image -->
      <nuxt-img
        class="absolute object-cover object-top w-full h-full"
        sizes="xs:330px sm:440px md:760px lg:1024px xl:1200px 2xl:1400px"
        preload
        fetchpriority="high"
        loading="eager"
        format="webp"
        :src="backgroundImageSrc"
        :alt="backgroundImageAlt"
      />
  
      <div class="relative mx-auto max-w-screen-2xl">
        <!-- News Banner -->
        <nuxt-img
          class="absolute w-32 md:w-40 right-3 md:right-6 md:top-6 top-3 lg:w-48"
          sizes="xs:128px sm:128px md:128px lg:160px xl:204px 2xl:204px"
          preload
          fetchpriority="high"
          format="webp"
          :src="newsBannerSrc"
          :alt="newsBannerAlt"
        />
  
        <!-- Content Container -->
        <div class="relative max-w-screen-md px-4 mx-auto">
          <div class="py-20 xl:py-36 lg:py-28 xs-max:pb-10">
            <!-- Headings -->
            <h1 class="text-2xl font-bold text-center text-white sm:text-3xl lg:text-4xl xl:text-40" v-html="mainHeading"></h1>
            <h2 class="mt-2 text-4xl font-bold text-center text-white sm:mt-4 sm:text-5xl lg:text-6xl xl:text-7xl" v-html="subHeading"></h2>
  
            <!-- Description -->
            <div
              class="max-w-lg mx-auto mt-2 text-base leading-6 text-center text-white font-ww-light lg:max-w-full sm:mt-6 sm:text-lg lg:text-xl 2xl:text-22"
              v-html="descriptionText"
            ></div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  const props = defineProps({
    mainHeading: {
      type: String,
      default: 'Coffee Prices Are Set to',
    },
    subHeading: {
      type: String,
      default: 'SKYROCKET in 2025...',
    },
    descriptionText: {
      type: String,
      default:
        "Here's how savvy coffee drinkers are 'freezing' their prices and saving hundreds with our Anti-Inflation Shield subscription program.",
    },
    backgroundImageSrc: {
      type: String,
      default: '/assets/images/hero-news.jpg',
    },
    backgroundImageAlt: {
      type: String,
      default: 'Background Hero Image',
    },
    newsBannerSrc: {
      type: String,
      default: '/assets/images/news-banner.png',
    },
    newsBannerAlt: {
      type: String,
      default: 'News Banner',
    },
  });
  defineBuilderComponent({
    friendlyName: 'HeroHighlightNews',
    inputs: [
      {
        name: 'mainHeading',
        type: 'richText',
        friendlyName: 'Main Heading',
        defaultValue: 'Coffee Prices Are Set to',
      },
      {
        name: 'subHeading',
        type: 'richText',
        friendlyName: 'Subheading',
        defaultValue: 'SKYROCKET in 2025...',
      },
      {
        name: 'descriptionText',
        type: 'richText',
        friendlyName: 'Description Text',
        defaultValue:
          "Here's how savvy coffee drinkers are 'freezing' their prices and saving hundreds with our Anti-Inflation Shield subscription program.",
      },
      {
        name: 'backgroundImageSrc',
        type: 'file',
        friendlyName: 'Background Image',
        allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
        defaultValue: '/assets/images/hero-news.jpg',
      },
      {
        name: 'backgroundImageAlt',
        type: 'text',
        friendlyName: 'Background Image Alt Text',
        defaultValue: 'Background Hero Image',
      },
      {
        name: 'newsBannerSrc',
        type: 'file',
        friendlyName: 'News Banner Image',
        allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
        defaultValue: '/assets/images/news-banner.png',
      },
      {
        name: 'newsBannerAlt',
        type: 'text',
        friendlyName: 'News Banner Alt Text',
        defaultValue: 'News Banner',
      },
    ],
  });
  </script>
  